import React from 'react';
import Styles from './index.less';
import { Feature } from '@tencent/workbench';
import { config, TransitionList } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import SelectablePanel from '@framework/workbench/common/components/selectable-panel';
import i18n from '@i18next/i18n';
import { IReactionDisposer } from 'mobx/lib/internal';
import TransitionCard from '@framework/workbench/common/components/selectable-panel/transition-card';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { reaction } from 'mobx';

// Panel中展示的个数
const PANEL_COL_NUM = 10;

@Feature()
export class TransitionChangeFeature extends BaseSelectablePanelFeature {
    public id = config.id;
    public config = config;
    public initReaction: IReactionDisposer;
    private previewTimer: NodeJS.Timeout;

    public constructor() {
        super();

        this.initReaction = reaction(() => this.currentSlide, () => {
            this.toolbarService.$forceUpdate();
        });
    }

    public getContent() {
        return <div className={Styles['transition-change']}>
            <SelectablePanel
                expandHeight={126}
                colNumber={PANEL_COL_NUM}
                showArrow={true}
                selectedId={this.currentSlideTransitionType}
                defaultShowIndex={this.getSelectablePanelShowIndex()}
                childrenElements={
                    [
                        {
                            name: i18n.t('细微'),
                            cardList: TransitionList.map(item => ({
                                element: <TransitionCard
                                    key={item.type}
                                    icon={item.icon}
                                    type={item.type}
                                    text={item.text}
                                    onClick={this.handleCardClick}
                                    id={item.type}
                                    tooltip={item?.tooltip}
                                />,
                                id: item.type,
                            })),
                        },
                    ]
                } />
        </div>;
    }

    private getSelectablePanelShowIndex() {
        const selectedIndex = this.getSelectedIndex();
        const listLength = TransitionList.length;

        // 如果选中的索引小于列数，直接返回 0
        if (selectedIndex < PANEL_COL_NUM) {
            return 0;
        }

        const colOffset = Math.floor(selectedIndex / PANEL_COL_NUM);

        // 如果列表总数一行无法填满，就倒推索引
        if (listLength < (PANEL_COL_NUM * (colOffset + 1))) {
            return listLength - PANEL_COL_NUM;
        }

        // 返回列偏移量乘以列数
        return colOffset * PANEL_COL_NUM;
    }

    private getSelectedIndex() {
        let selectedIndex = 0;
        TransitionList.find(((item, index) => {
            if (item.type === this.currentSlideTransitionType) {
                selectedIndex = index;
            }
        }));

        return selectedIndex;
    }

    private handleCardClick = (type: TransitionType) => {
        this.transitionService?.promise().then((module) => {
            module.updateTransitionType(type);

            if (module.autoPreviewState) {
                clearTimeout(this.previewTimer);

                // 更新model之后会触发 slide-wrapper的update，里面会reset transition-layer
                // 这里延迟预览，保证以新的layer context进行preview
                this.previewTimer = setTimeout(() => {
                    module.preview();
                }, 100);
            }
        });
    };

    private get transitionService() {
        return this.getAppService().editableServiceLayer?.transitionService;
    }


    private get currentSlideTransitionType() {
        const type = this.currentSlideTransition?.type;

        // newsflash 是 warp 菜单下的一种效果，但是独立除了一种type
        if (type === TransitionType.NEWSFLASH) {
            return TransitionType.WARP;
        }

        return type || TransitionType.EMPTY;
    }

    private get currentSlide() {
        return this.getAppService().viewableServiceLayer.selectionService.currentSlide;
    }

    private get currentSlideTransition() {
        return this.currentSlide?.transition;
    }
}
